"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Styling_1 = require("../../Styling");
exports.getClassNames = Utilities_1.memoizeFunction(function (styles, theme) {
    styles = styles || {};
    return Styling_1.mergeStyleSets({
        title: [{
                fontSize: '16px',
                paddingRight: '14px',
                paddingLeft: '14px',
                paddingBottom: '5px',
                paddingTop: '5px',
                backgroundColor: theme.palette.neutralLight
            },
            styles.title
        ]
    });
});
//# sourceMappingURL=ContextualMenu.classNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ContextualMenu/ContextualMenu.classNames.js
// module id = 378
// module chunks = 0